import { call, put, takeLatest } from "redux-saga/effects";
import { httpGetAllTopics } from "../../../services/autoComplete";
import {
  getAllTopicsStart,
  getAllTopicsSuccess,
  getAllTopicsFailure,
} from "../reducer";

export function* getAllTopics({ payload }) {
  const response = yield call(httpGetAllTopics, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getAllTopicsSuccess(raw));
  } else {
    yield put(getAllTopicsFailure(message || raw.error));
  }
}

export default function* onGetAllTopics() {
  yield takeLatest(getAllTopicsStart.type, getAllTopics);
}
